import Tabs from "../../components/General/ResponsiveTabs/ResponsiveTabs";
import React, { useState } from "react";
import { Box, Tab, Switch, FormControlLabel } from "@mui/material";
import "../../assets/styles/pages/Fleet/moneyRequestPage.css";
import CreateRelayCodeButton from "../../components/Fleet/CreateRelayCodePopup/CreateRelayCodePopup";
import RelayPaymentsTable from "../../components/Fleet/RelayPaymentsTable/RelayPaymentsTable";

const PaymentsPage: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedGroup, setSelectedGroup] = useState("C1 Transportation");

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedGroup(
      event.target.checked ? "Fox C Group" : "C1 Transportation",
    );
  };

  return (
    <Box className="money-requests-page">
      <CreateRelayCodeButton company={selectedGroup} />
      <Box
        flexWrap={{ xs: "wrap", lg: "nowrap" }}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mt: 2 }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={selectedGroup === "Fox C Group"}
              onChange={handleSwitchChange}
              color="primary"
            />
          }
          label={`Selected Group: ${selectedGroup}`}
        />
      </Box>
      <Box sx={{ width: "100%", mt: 1 }}>
        <Tabs value={selectedTab} onChange={handleTabChange} centered>
          <Tab label="EFS" />
          <Tab label="Relay" />
        </Tabs>
        {selectedTab === 0 && (
          <Box className="tables-container">
            <div>Not integrated yet</div>
          </Box>
        )}
        {selectedTab === 1 && (
          <Box className="tables-container">
            <RelayPaymentsTable company={selectedGroup} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PaymentsPage;
